import styled from '@emotion/styled'
import { Container } from '@hhgtech/hhg-components/components'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import {
  StyledContentWrapper,
  StyledExpandableContainer,
  StyledExpandedCard,
  StyledHeading,
} from 'components/molecules/expandedCard/index.styled'

export const StyledWorkshopSection = styled.div`
  width: 100%;
  background: ${theme.colors.neutral50};
  ${MediaQueries.mbUp} {
    padding: 64px 0;
  }

  ${MediaQueries.mbDown} {
    padding: 24px 0;
  }
`

export const StyledWorkshopContainer = styled(Container)`
  ${MediaQueries.mbUp} {
    padding: 0 16px;
  }
`

export const StyledWorkshopSectionTitle = styled.h3`
  font-weight: 700;
  letter-spacing: -0.8px;
  line-height: 36px;
  ${MediaQueries.mbUp} {
    margin-bottom: 8px;
    font-size: 26px;
  }

  ${MediaQueries.mbDown} {
    margin-bottom: 16px;
    font-size: 20px;
  }
`

export const StyledWorkshopSectionDescription = styled.span`
  display: block;
  font-weight: 400;
  line-height: 24px;
  ${MediaQueries.mbUp} {
    font-size: 16px;
  }
  ${MediaQueries.mbDown} {
    font-size: 14px;
  }
`

export const StyledWorkshopCardWrapper = styled(Container)`
  display: flex;
  flex-wrap: wrap;
  ${MediaQueries.mbUp} {
    gap: 32px;
    margin-top: 40px;
    > div {
      width: calc(33% - 20px);
    }
  }

  ${MediaQueries.mbDown} {
    gap: 24px;
    margin-top: 16px;
    padding: 0;
    > div {
      width: 100%;
    }
  }
`

export const StyledGamingSection = styled.div`
  width: 100%;
  background-color: #f1f9ff;
  ul {
    padding-left: 20px;
    line-height: 1.3;
    li {
      position: relative;
      ::before {
        position: absolute;
        top: 8px;
        left: -15px;
        display: block;
        width: 4px;
        height: 4px;
        background-color: #000;
        border-radius: 50%;
        content: '';
      }
    }
  }
  ol {
    li {
      position: relative;
      padding-left: 23px;
      counter-increment: count;
      ::before {
        position: absolute;
        left: 5px;
        content: counter(count) '.';
      }
    }
  }
`

export const StyledStepCardWrapper = styled(Container)`
  display: flex;
  flex-wrap: wrap;
  ${MediaQueries.mbUp} {
    gap: 32px;
    margin-top: 40px;
    > div {
      width: calc(33% - 20px);
    }
  }

  ${MediaQueries.mbDown} {
    gap: 24px;
    margin-top: 16px;
    padding: 0 16px;
    > div {
      width: 100%;
    }
  }
`
export const StyledGamingSectionTitle = styled.h3`
  font-weight: 700;
  letter-spacing: -0.8px;
  line-height: 36px;
  ${MediaQueries.mbUp} {
    padding-bottom: 8px;
    font-size: 26px;
    padding-top: 79px;
    text-align: center;
  }

  ${MediaQueries.mbDown} {
    font-size: 20px;
    padding: 24px 16px 16px 16px;
  }
`
export const StyledGamingDescriptionWrapper = styled.div`
  ${MediaQueries.mbUp} {
    text-align: center;
  }
  ${MediaQueries.mbDown} {
    padding: 0 16px;
  }
`
export const StyledGamingSectionDescription = styled.span`
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  ${MediaQueries.mbUp} {
    font-size: 16px;
  }
  ${MediaQueries.mbDown} {
    font-size: 14px;
  }
`

export const StyledGamingBanner = styled.a``

export const StyledRewardContainer = styled(Container)`
  padding-bottom: 40px;
  ${MediaQueries.mbUp} {
    display: flex;
    align-items: center;
    gap: 150px;
    padding-top: 80px;
    margin-bottom: 64px;
  }
  ${MediaQueries.mbDown} {
    padding-top: 50px;
    img {
      margin-bottom: 16px;
    }
  }
`

export const StyledRewardInfo = styled.div`
  width: 100%;
  height: 100%;
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius};
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.04);
  ${MediaQueries.mbUp} {
    padding-top: 12px;
  }
  ${MediaQueries.mbDown} {
    padding-top: 8px;
  }

  li + li {
    margin-top: 8px;
  }
  ${StyledHeading} {
    svg {
      margin-right: 16px;
    }
    padding: 13px 16px 11px;
    ${MediaQueries.mbDown} {
      padding: 12px 16px;
      svg {
        margin-right: 10px;
      }
    }
  }
  ${StyledContentWrapper} {
    margin: 0;
  }
  ${StyledExpandedCard} {
    margin: 0;
  }
  ${StyledExpandableContainer} {
    margin: 0;
  }
`

export const StyledRewardImage = styled.div``
